import { components } from 'gridstrap/lib/gs-components';
import { GSFaqList } from './faq-list';
import './faq-list.scss';

components.register({
	selector: '.gs-FaqList',
	controller: GSFaqList
})
